import { useTheme } from '@mui/material';
import { Box, Typography } from '@mui/material';
import { DAY_LABELS, RULER_H, RULER_TOP } from './constants';
import FlexBetween from 'components/FlexBetween';


const WeekDayRuler = ({ dayW }) => {
  const theme   = useTheme();
  const hourW    = dayW / 24;
  const hourStep = hourW < 12 ? 6 : hourW < 22 ? 4 : hourW < 42 ? 2 : 1;

  return (
    <Box sx={{ display: 'flex', flexShrink: 0 }}>
      {[1, 2, 3, 4, 5, 6, 7].map((d) => {
        const isWeekend = d >= 6;
        return (
          <Box 
            key={d} 
            sx={{
              width: dayW, 
              flexShrink: 0, 
              position: 'relative', 
              height: RULER_H,
              bgcolor: isWeekend ? 'warning.darkest' : 'background.alt',
              borderRight: `1px solid ${theme.palette.divider}`,
            }}
          >
            {/* Day name */}
            <FlexBetween 
              sx={{
                height: RULER_TOP, 
                borderBottom: `1px solid ${theme.palette.divider}`, 
                gap: 1,
              }}
            >
              <Typography 
                sx={{
                  fontSize: '0.7rem', 
                  fontFamily: 'monospace', 
                  fontWeight: 600, 
                  userSelect: 'none',
                  color: d === 7 ? 'rose.main' : d === 6 ? 'warning.main' : 'text.primary',
                }}
              >
                {DAY_LABELS[d]}
              </Typography>
            </FlexBetween>

            {/* Hour ticks */}
            <Box sx={{ position: 'absolute', top: RULER_TOP + 1, left: 0, right: 0, bottom: 0, display: 'flex' }}>
              {Array.from({ length: 24 / hourStep }, (_, i) => {
                const h       = i * hourStep;
                const isMajor = h % 6 === 0;
                return (
                  <FlexBetween 
                    key={h} 
                    sx={{
                      width: `${(hourStep / 24) * 100}%`, 
                      height: '100%',                      
                      borderRight: `1px solid ${isMajor ? theme.palette.divider : theme.palette.action.disabledBackground}`,
                      bgcolor: isMajor && h !== 0 ? 'action.hover' : 'transparent',
                    }}
                  >
                    <Typography sx={{
                      fontSize: isMajor ? '0.6rem' : '0.55rem', fontFamily: 'monospace',
                      color: isMajor ? 'text.secondary' : 'text.disabled',
                      userSelect: 'none', lineHeight: 1,
                    }}>
                      {String(h).padStart(2, '0')}
                    </Typography>
                  </FlexBetween>
                );
              })}
            </Box>

            {/* Night shading on ruler */}
            <Box sx={{ position: 'absolute', left: 0, width: `${(6 / 24) * 100}%`, top: RULER_TOP + 1, bottom: 0, bgcolor: 'rgba(0,0,0,0.25)', pointerEvents: 'none' }} />
            <Box sx={{ position: 'absolute', left: `${(22 / 24) * 100}%`, right: 0, top: RULER_TOP + 1, bottom: 0, bgcolor: 'rgba(0,0,0,0.25)', pointerEvents: 'none' }} />
          </Box>
        );
      })}
    </Box>
  );
};

export default WeekDayRuler;
